module.exports = __webpack_public_path__ + "img/ministryOfHealthLogo.c86f71f0.png";